// import { Link } from "react-router-dom";
// import PageBanner from "../../PageBanner";
// import SocialMediaSidebar from "../../SocialMediaSidebar";
// import SectionHeader from "../../SectionHeader";
// import ScrollToTopButton from "../../ScrollToTopButton";
// import alert from "../../../assets/images/alert.png"
// import cc from "../../../assets/images/cc.png"

// const OfferingParkingAlert = () => {
//   return (
//     <>
//       <div>
//         <SocialMediaSidebar />
//       </div>
//       <PageBanner
//         title="Connectivity & Communication"
//         breadcrumb={[
//           { label: "Home", href: "/" },
//           { label: "Offerings" },
//         ]}
//       />
//       <div className="max-w-6xl mx-auto p-4">
//         <SectionHeader
//           title="Connectivity & Communication @ AJEEVI"
//           shareUrl="https://swmecom.ajeevi.in/data-insights"
//         />
//       </div>
//       <div>
//         <ScrollToTopButton />
//       </div>

//       {/* Page content */}
//      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
//   <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//     {/* Summary Section */}
//     <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-10">
//       {/* Text Section */}
//       <div className="md:w-1/2">
//         <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//           Summary
//         </h4>
//         <p className="text-black mb-4 text-lg">
//           Modern Connectivity & Communication systems transform urban parking management by enabling seamless internet access and real-time data sharing through built-in Wi-Fi routers and advanced networking solutions. This technology significantly improves operational coordination while reducing communication delays and infrastructure costs.
//         </p>
//         <p className="text-black text-lg">
//           Cities and parking operators implementing robust connectivity solutions achieve higher system integration, faster response times, and improved data analytics through continuous network availability.
//         </p>
//       </div>

//       {/* Image Section */}
//       <div className="md:w-1/2">
//         <img
//           src={cc}
//           alt="Parking Connectivity Solutions"
//           className="w-full h-auto rounded-lg shadow-md"
//         />
//       </div>
//     </div>

//     {/* Introduction Section */}
//     <div className="mb-10">
//       <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//         Introduction
//       </h4>
//       <p className="text-black mb-4 text-lg">
//         Traditional parking systems often suffer from communication gaps and data silos. Modern Connectivity & Communication solutions leverage wireless networks, cloud platforms, and IoT protocols to enable instant data sharing and system-wide coordination.
//       </p>
//       <p className="text-black text-lg">
//         By combining high-speed internet access, mesh networking, and mobile communication tools, these systems create an interconnected parking ecosystem that supports real-time analytics and remote management.
//       </p>
//     </div>

//     {/* Key Features Section */}
//     <div className="mb-10">
//       <h5 className="text-xl font-semibold mb-4 text-black">
//         Key Features of Connectivity & Communication Systems:
//       </h5>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//         <li>
//           <strong>Built-in Wi-Fi Hotspots:</strong> Provide seamless internet access for devices and users throughout the parking facility
//         </li>
//         <li>
//           <strong>Real-Time Data Transmission:</strong> Instant synchronization of parking status and payment information
//         </li>
//         <li>
//           <strong>Mesh Network Capabilities:</strong> Self-healing wireless networks ensure continuous connectivity
//         </li>
//         <li>
//           <strong>Multi-Protocol Support:</strong> Compatibility with cellular, LoRaWAN, Bluetooth, and other communication standards
//         </li>
//         <li>
//           <strong>Cloud Integration:</strong> Secure data storage and processing in centralized platforms
//         </li>
//         <li>
//           <strong>Remote Management:</strong> System monitoring and configuration from any internet-connected device
//         </li>
//       </ul>
//     </div>

//     {/* Benefits Section */}
//     <div className="mb-10">
//       <h5 className="text-xl font-semibold mb-3 text-black">
//         Operational Benefits
//       </h5>
//       <p className="text-black text-lg mb-4">
//         Implementing robust connectivity solutions delivers measurable improvements:
//       </p>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li>90-99% network uptime for continuous operations</li>
//         <li>60-80% reduction in communication infrastructure costs</li>
//         <li>50-70% faster data transmission compared to traditional systems</li>
//         <li>Seamless integration with third-party applications and services</li>
//         <li>Real-time alerts and notifications for immediate response</li>
//         <li>Scalable architecture that grows with your operations</li>
//       </ul>
//     </div>

//     {/* Implementation Section */}
//     <div className="mb-10">
//       <h5 className="text-xl font-semibold mb-3 text-black">
//         Implementation Considerations
//       </h5>
//       <p className="text-black text-lg mb-4">
//         Effective connectivity system deployment requires:
//       </p>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li>Strategic placement of wireless access points for optimal coverage</li>
//         <li>Redundant network paths to ensure continuous operation</li>
//         <li>Cybersecurity measures to protect data and system integrity</li>
//         <li>Bandwidth planning to accommodate current and future needs</li>
//         <li>Compatibility assessment with existing hardware and software</li>
//         <li>Staff training on network management and troubleshooting</li>
//       </ul>
//     </div>

//     {/* Ajeevi's Contribution Section */}
//     <div>
//       <h5 className="text-xl font-semibold mb-3 text-black">
//         Ajeevi's Connectivity Solutions
//       </h5>
//       <p className="text-black mb-4 text-lg">
//         Ajeevi offers comprehensive communication and networking systems:
//       </p>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li>
//           <strong>Smart Network Infrastructure:</strong> Reliable wireless connectivity throughout parking facilities
//         </li>
//         <li>
//           <strong>Cloud Communication Platform:</strong> Centralized data exchange and system management
//         </li>
//         <li>
//           <strong>IoT Gateway Solutions:</strong> Bridge between devices and management systems
//         </li>
//         <li>
//           <strong>Real-Time Data Analytics:</strong> Instant processing of parking information
//         </li>
//         <li>
//           <strong>Mobile Integration:</strong> Seamless connection with enforcement and payment apps
//         </li>
//       </ul>
//       <p className="text-black text-lg">
//         Discover how Ajeevi's Connectivity & Communication solutions can enhance your parking operations. Visit{" "}
//         <a
//           href="http://www.ajeevi.com"
//           target="_blank"
//           rel="noopener noreferrer"
//           className="text-[#00D084] hover:underline"
//         >
//           www.ajeevi.com
//         </a>{" "}
//         for more information.
//       </p>
//     </div>
//   </div>
// </div>
//     </>
//   );
// };

// export default OfferingParkingAlert;


import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import ScrollToTopButton from "../../ScrollToTopButton";
import cc from "../../../assets/images/cc.png";

const OfferingParkingAlert = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Smart Connectivity"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Offerings" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Smart Connectivity @ AJEEVI"
          shareUrl="https://swmecom.ajeevi.in/data-insights"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Summary Section */}
          <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-10">
            {/* Text Section */}
            <div className="md:w-1/2">
              <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
                Summary
              </h4>
              <p className="text-black mb-4 text-lg">
                Built-in Wi-Fi routers are the backbone of Smart Connectivity, enabling seamless real-time communication and data exchange across smart city devices and infrastructure. These systems ensure that connected assets remain synchronized, efficient, and remotely manageable.
              </p>
              <p className="text-black text-lg">
                With always-on connectivity, urban systems such as surveillance, environmental sensors, traffic management, and public services become faster, smarter, and more responsive.
              </p>
            </div>

            {/* Image Section */}
            <div className="md:w-1/2">
              <img
                src={cc}
                alt="Smart Connectivity Solutions"
                className="w-full h-auto rounded-lg shadow-md"
              />
            </div>
          </div>

          {/* Introduction Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Introduction
            </h4>
            <p className="text-black mb-4 text-lg">
              In the era of digital cities, connectivity is essential. Smart Connectivity uses embedded Wi-Fi routers and IoT gateways to interlink urban systems, enabling smooth data flows and system-wide coordination without manual intervention.
            </p>
            <p className="text-black text-lg">
              This infrastructure transforms how devices interact—creating a dynamic, interconnected ecosystem that improves service delivery, maintenance, and public engagement.
            </p>
          </div>

          {/* Key Features Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-4 text-black">
              Key Features of Smart Connectivity:
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black">
              <li><strong>Embedded Wi-Fi Routers:</strong> Ensure reliable and high-speed communication</li>
              <li><strong>IoT Protocol Support:</strong> Seamless data exchange between sensors and platforms</li>
              <li><strong>Cloud Integration:</strong> Centralized data management and analytics</li>
              <li><strong>Scalable Architecture:</strong> Easily expandable to accommodate growing infrastructure</li>
              <li><strong>Real-Time Synchronization:</strong> Enables instant decision-making and automation</li>
              <li><strong>Remote Management:</strong> Monitor and configure systems from any location</li>
            </ul>
          </div>

          {/* Operational Benefits Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Operational Benefits
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Reduced manual intervention and improved system efficiency</li>
              <li>Continuous uptime for critical city services</li>
              <li>Faster data collection and response rates</li>
              <li>Better coordination between city departments and systems</li>
              <li>Enhanced citizen experience through uninterrupted services</li>
              <li>Lower operational costs via remote monitoring and troubleshooting</li>
            </ul>
          </div>

          {/* Implementation Considerations */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Implementation Considerations
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Optimal placement of connectivity hardware for maximum coverage</li>
              <li>High-reliability power supply and network redundancy</li>
              <li>Regular updates and security patches</li>
              <li>Interoperability with legacy and modern systems</li>
              <li>Training for city personnel on network management</li>
              <li>Scalability planning for future expansion</li>
            </ul>
          </div>

          {/* Ajeevi's Contribution Section */}
          <div>
            <h5 className="text-xl font-semibold mb-3 text-black">
              Ajeevi's Smart Connectivity Solutions
            </h5>
            <p className="text-black mb-4 text-lg">
              Ajeevi enables urban digital transformation with Smart Connectivity platforms:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li><strong>Integrated Wi-Fi Routers:</strong> High-speed, low-latency communication</li>
              <li><strong>Modular Connectivity Layers:</strong> Support multiple IoT standards</li>
              <li><strong>Secure Cloud Services:</strong> Real-time dashboards and analytics</li>
              <li><strong>End-to-End Integration:</strong> From devices to platforms, fully connected</li>
              <li><strong>Reliable Support:</strong> Maintenance, updates, and technical services</li>
            </ul>
            <p className="text-black text-lg">
              Learn more about how Ajeevi's Smart Connectivity can power your digital infrastructure. Visit{" "}
              <a
                href="http://www.ajeevi.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00D084] hover:underline"
              >
                www.ajeevi.com
              </a>{" "}
              for details.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferingParkingAlert;
